import { createClient } from "@supabase/supabase-js";
import { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from "./config";
import type { Database } from "./db-types";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Σταθερό κλειδί αποθήκευσης ώστε η συνεδρία να ξαναφορτώνεται αξιόπιστα
    // στο άνοιγμα του browser και να μη «χάνεται» σε ανανεώσεις του app.
    storageKey: "mrpanda-auth",
    storage: typeof window !== "undefined" ? window.localStorage : undefined,
  },
});
